<template>
  <div class="subject-detail" v-loading="loading">
    <div class="course_management_wrap">
        <div class="course_management_title">
            <div class="header_title_img">
                <div class="header_title_img cursor" @click="back">
                <img :src="return_img" />
                </div>
                <h2>科目详情</h2>
            </div>
            <el-button
                v-if="$_has('zledu.jiaoxue.sourcesubject.delete')"
                class="header_button"
                size="small"
                @click="delSubject()"
            >删除此科目</el-button>
        </div>
    </div>
    <div class="subject_wrap" :style="{height:styleSheet}">
      <div class="subject-detail-name">
        <div class="ipt-wrap">
            <span>科目名称</span>
            <el-input v-model="subjectName" :disabled="disabled" maxlength="20"></el-input>
            <span>科目编码</span>
            <el-input v-model="subjectCode" :disabled="disabled" maxlength="20"></el-input>
            <img :src="img_edit" @click="editorIpt()">
        </div>
        <div class="btn-wrap" v-if="!disabled">
            <el-button class="header_button" @click="confirm()">确认</el-button>
            <el-button class="header_button" @click="cancel()">取消</el-button>
        </div>
      </div>
      <div class="subject-detail-teacher">
          <h2>科目老师</h2>
          <el-button class="header_button" size="small" @click="showTeacher()">添加老师</el-button>
      </div>
      <div class="teacher-table">
          <el-table
              :data="teacherData"
              style="width: 100%"
              height="200px"
              :header-cell-style="headerCellStyle"
              class="collegeTable"
              :empty-text="empty"
          >
              <el-table-column prop="name" label="教师姓名"></el-table-column>
              <el-table-column prop="jobNumber" label="工号"></el-table-column>
              <el-table-column prop="mobile" label="手机号">
                <template slot-scope="scope">
                  <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="userName" label="账号"></el-table-column>
              <el-table-column fixed="right" label="操作" width="auto">
                  <template slot-scope="scope">
                      <el-button
                      @click.native.prevent="delRow(scope.$index, teacherData)"
                      round
                      size="small"
                      >删除</el-button>
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <div class="subject-detail-catalog">
          <h2>知识点</h2>
      </div>
      <div class="catalog-tree">
          <el-tree
            :data="materials"
            node-key="id"
            :props="defaultProps"
            draggable
            @node-drop="handleDrop"
            ref="tree"
            :default-expanded-keys="defaultExpansion"
            empty-text="暂无目录"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <el-input
                class="nodeInput"
                v-if="data.status == 0"
                style="width: 90%; margin-right: 20px;"
                v-model="data.name"
                size="small"
                :ref="'edit'+data.id"
                @blur="blurEdit(data, node)"
                @keyup.enter.native="$event.target.blur"
                maxlength="100"
              ></el-input>
              <span v-else class="father" :title="node.label">{{ node.label }}</span>
              <span class="child">
                <el-button round v-if="data.status == 1" @click.stop="() => append(node, data)" title="添加" size="mini">
                  添加
                </el-button>
                <el-button round class="item" v-if="data.status == 1" @click.stop="() => edit(node, data)" title="编辑" size="mini">
                  编辑
                </el-button>
                <el-button round class="item" v-if="data.status == 1" @click.stop="() => remove(node, data)" title="删除" size="mini">
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
          <a class="header_button" @click="addTree()"><img src="../../../../../static/images/addclass.png">添加目录</a>
      </div>
      <div class="subject-detail-catalog">
        <h2>岗位</h2>
      </div>
      <div class="add_post">
        <ul>
          <li v-for="(item,key) in postList" :key="key">
            <span>{{item.name}}</span>
            <div>
              <el-button round size="mini" @click="editPost(item)">编辑</el-button>
              <el-button round size="mini" @click="deletePost(item.id)">删除</el-button>
            </div>
          </li>
        </ul>
        <a class="header_button" @click="addPost()"><img src="../../../../../static/images/addclass.png">添加岗位</a>
      </div>
      <div class="subject-detail-catalog">
        <h2>公司</h2>
      </div>
      <div class="add_company">
        <ul>
          <li v-for="(item,key) in companyList" :key="key">
            <span>{{item.name}}</span>
            <div>
              <el-button round size="mini" @click="editCompany(item)">编辑</el-button>
              <el-button round size="mini" @click="deleteCompany(item.id)">删除</el-button>
            </div>
          </li>
        </ul>
        <a class="header_button" @click="addCompany()"><img src="../../../../../static/images/addclass.png">添加公司</a>
      </div>
    </div>
    <!-- 添加老师 -->
    <el-dialog
      title="添加老师"
      :visible.sync="teacherDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="832px"
    >
      <div class="teacher-content">
        <div class="left">
          <div class="left-top">
            <el-input placeholder="请输入姓名或手机号" prefix-icon="el-icon-search" v-model="nameMobile" @keyup.enter.native="search()"></el-input>
            <el-button plain @click="search()">查 询</el-button>
          </div>
          <div class="left-table">
            <el-table
              :data="teacherDataCheck"
              style="width: 100%"
              height="282px"
              :header-cell-style="headerCellStyleTeacher"
              class="collegeTable"
              ref="multipleTable"
              :empty-text="empty"
              @selection-change="handleSelectionChange"
              :header-cell-class-name="cellClass"
              v-loading="tabload"
            >
              <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
              <el-table-column prop="name" label="教师姓名"></el-table-column>
              <el-table-column prop="userName" label="账号"></el-table-column>
              <el-table-column prop="mobile" label="手机号">
                <template slot-scope="scope">
                  <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="right">
          <div class="right-top">
            <span>已选</span>
            <div class="imgBox" @click="emptyTeacher(teacherDataCheck)">
              <img src="../../../../../static/images/shanchu.png" alt="">
              清空
            </div>
          </div>
          <div class="right-cont">
            <li class="name_item" v-for="(item,index) in multipleSelection" :key="index" :title="item.name">
              {{item.name}}
            </li>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTrainingeSite(false)">取消</el-button>
        <el-button type="primary" @click="handleTrainingeSite(true)">保存</el-button>
      </span>
    </el-dialog>
    <add-post
     :title="postTitle"
     :showModalconfirm="postVisible"
     :newPostForm="newPostForm"
     @cancelAddPost="cancelAddPost"
     @confirmAddPost="confirmAddPost"></add-post>
    <add-company
     :title="companyTitle"
     :showModalconfirm="companyVisible"
     :newCompanyForm="newCompanyForm"
     @cancelAddCompany="cancelAddCompany"
     @confirmAddCompany="confirmAddCompany"></add-company>
  </div>
</template>

<script>
import addPost from './subjectDialog/addPostDialog'
import addCompany from './subjectDialog/addCompanyDialog'
import {desensitization} from "@/utils/utils";
export default {
  filters:{
    desensitizationText(val){
      return desensitization(val)
    }
  },
  components:{
    addPost,
    addCompany
  },
  data() {
    return {
      loading:true,
      return_img: require("../../../../../static/images/fanhui.png"),
      img_edit: require("../../../../../static/images/bianji.png"),
      subjectName:'',
      subjectCode:'',
      teacherData:[],
      empty:'暂无数据',
      materials:[],
      defaultProps: {
        label: "name"
      },
      defaultExpansion:[],
      adminLoading:true,
      styleSheet:window.innerHeight - 156 +'px',
      disabled:true,
      teacherDialogVisible:false,
      nameMobile:'',
      teacherDataCheck:[],
      multipleSelection:[],
      selectedData:[],
      tabload:true,
      subjectObj:{
      	name:'',
      	code:''
      },
      //添加岗位
      postList: [],
      postTitle:'',
      postVisible: false,
      editPostId: '',
      newPostForm:{
        postName:'',
        postCode:''
      },
      //添加公司
      companyList: [],
      companyTitle: '',
      companyVisible: false,
      editCompanyId: '',
      newCompanyForm:{
        companyName:'',
        companyCode:'',
        useScope:[]
      },
    };
  },
  created() {
      this.getTeacherList();
      this.getTree();
      this.subjectName = this.$route.query.subjectName;
      this.subjectCode = this.$route.query.subjectCode;
      this.subjectObj.name = this.subjectName;
      this.subjectObj.code = this.subjectCode;
      // 岗位列表
      this.getPostList()
      //公司列表
      this.getCompanyList()
  },
  methods: {
    headerCellStyle(row, column, rowIndex, columnIndex){
      return "background:rgba(83,151,247,0.1);color:#999999";
    },
    headerCellStyleTeacher(row, column, rowIndex, columnIndex){
      return "background:rgba(83,151,247,0.1);color:#999999";
    },
    cellClass(row){
      if (row.columnIndex === 0) {//你需要判断的条件
        return 'disabledCheck'
      }
    },
    // 编辑科目名称
    editorIpt(){
      this.disabled = false;
    },
    // 确认科目名称编辑
    confirm(){
        if (this.subjectName && this.subjectCode) {
          this.$ajax
            .put("/api-resource/cjdd-resources/subject/name", {
              subjectName: this.subjectName,
              subjectId: this.$route.query.subjectId,
              code:this.subjectCode
            })
            .then(res => {
              if (res.data.code === "0") {
            		this.subjectObj.name = this.subjectName;
            		this.subjectObj.code = this.subjectCode;
                this.disabled = true;
                this.$messageSuccess('修改科目成功');
              } else {
                this.$messageError('修改科目失败');
                return;
              }
            });
        } else {
          this.$messageError('科目名称和科目编码不能为空');
        }
    },
    // 取消科目名称编辑
    cancel(){
      this.subjectName = this.subjectObj.name;
      this.subjectCode = this.subjectObj.code;
      this.disabled = true;
    },
    // 返回上一级
    back(){
      this.$router.go(-1);
    },
    // 科目删除
    delSubject() {
        let id = this.$route.query.subjectId;
        this.$confirm("是否确认删除该条科目?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
        .then(() => {
        this.$ajax
            .delete(
            "/api-resource/cjdd-resources/subject/" + id )
            .then(res => {
            if (res.data.code === "0") {
                this.$messageSuccess('删除成功')
                this.$router.go(-1);
            } else if (res.data.code === "00002") {
                this.$messageError(res.data.msg);
            }
            });
        })
        .catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
        });
    },
    // 获取教师信息
    getTeacherList(){
      this.$ajax.get('/api-resource/cjdd-resources/subject/teachers/'+ this.$route.query.subjectId).then(res=>{
        if(res.data.code == 0){
            this.teacherData = res.data.data;
            this.loading = false;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    // 获取目录信息
    getTree(){
        let id = this.$route.query.subjectId;
        this.$ajax.get("/api-resource/cjdd-resources/resourses/get/material/catalog/" + id)
        .then(res => {
          this.materials = res.data.data.materials;
          this.adminLoading = false;
        });
    },
    // 添加一级目录
    addTree() {
      let len = this.materials.length;
      var obj = {
        parentId: 0,
        subjectId: this.$route.query.subjectId,
        name: '新增目录',
      };
      this.$ajax.post('/api-resource/cjdd-resources/resourses/insert/material/node', obj).then((res)=>{
        if (res.data.code == "0") {
          let resData= res.data.data;
          let newObj = {
            children:resData.children,
            id:resData.id,
            name:resData.name,
            parentFlag:resData.parentFlag,
            parentId:resData.parentId,
            sort:resData.sort,
            status:resData.status,
            subjectId:resData.subjectId,
            subjectName:resData.subjectName,
            updateTime:resData.updateTime,
            updateUser:resData.updateUser
          }
          this.materials.push(newObj);
          this.edit('node', newObj);
        }
      }).catch((error)=>{
        console.log(error)
      });
    },
    // 新增子目录
    append(node,data) {
      if(node.level>=5){
        this.$messageWarning('最多只能添加五级节点')
      }else{
        let obj = {
          name: "新增子目录",
          parentId:data.id,
          subjectId:data.subjectId
        };
        this.$ajax.post('/api-resource/cjdd-resources/resourses/insert/material/node', obj).then((res)=>{
          if (res.data.code == "0") {
            let resData= res.data.data;
            const newChild = {
              children:resData.children,
              id:resData.id,
              name:resData.name,
              parentFlag:resData.parentFlag,
              parentId:resData.parentId,
              sort:resData.sort,
              status:resData.status,
              subjectId:resData.subjectId,
              subjectName:resData.subjectName,
              updateTime:resData.updateTime,
              updateUser:resData.updateUser
            }
            if (!data.children) {
              this.$set(data, 'children', []);
            }
            data.children.push(newChild);
            this.defaultExpansion.push(newChild.id);
            this.edit('node', newChild);
          }
        }).catch((error)=>{
          console.log(error)
        });
      }
    },
    // 编辑tree input 失去焦点
    blurEdit(data, node) {
      if(data.name==""){
        this.$set(data, "status", 0);
        this.$nextTick(() => {
          this.$refs['edit'+data.id].$refs.input.focus();
        })
        this.$messageError('目录名称不能为空');
        return
      }
      this.$ajax.put(`/api-resource/cjdd-resources/resourses/update/material/node?id=${data.id}&name=${data.name}`).then(res => {
        if (res.data.code == "0") {
          this.$messageSuccess('保存成功!')
          this.$set(data, "status", 1);
        }
      }).catch(error => {
        console.log(error);
      });
      $('.catalog-tree').find('button').removeAttr('disabled')
    },
    // 编辑节点
    edit(node, data) {
      $('.catalog-tree').find('button').attr('disabled',true)
      let _this = this;
      this.$set(data, "status", 0);
      this.$nextTick(() => {
       let timer = setTimeout(()=>{
          this.$refs['edit'+data.id].$refs.input.focus();
          clearTimeout(timer)
        },30)
      });
    },
    // 目录节点拖拽完成
    handleDrop(before,after,inner,$event){
      let level = 0;
      if(inner == 'before'){
        level = 0
      }else if(inner == 'inner'){
        level = 1
      }else if(inner == 'after'){
        level = 2
      }
      // 拖拽成功完成时触发的事件
      let obj = {
        catalogId: before.data.id,
        progessionId: before.data.subjectId,
        level: level,
        targetId: after.data.id
      }
      this.$ajax.put(`/api-resource/cjdd-resources/resourses/catalog`,obj).then((rs)=>{
        if(rs.data.code == 0){
          console.log('移动成功')
        }
      }).catch((error)=>{
        console.log(error)
      })
    },
    //删除节点
    remove(node, data) {
      if (data.children && data.children.length !== 0) {
        this.$messageWarning('此节点有子节点不可删除!')
      }else {
        this.$confirm("是否删除该节点?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
            this.$ajax.delete(`/api-resource/cjdd-resources/resourses/delete/material/node/${data.id}`).then(res => {
                if (res.data.code == "0") {
                  const parent = node.parent;
                  const children = parent.data.children || parent.data;
                  const index = children.findIndex(d => d.id === data.id);
                  children.splice(index, 1);
                  this.$messageSuccess('删除成功!')
                }else if(res.data.code == "1"){
                  this.$messageError(res.data.msg);
                  return
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消删除"
            // });
          });
      }
    },
    // 删除老师
    delRow(index, rows){
        let fd = new FormData();
        fd.append('subjectId',rows[index].subjectId);
        fd.append('userId',rows[index].userId);
        this.$confirm("是否确认删除该老师?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
        .then(() => {
            this.$ajax.delete("/api-resource/cjdd-resources/subject/teacher?subjectId="+rows[index].subjectId+'&userId='+rows[index].userId)
                .then(res => {
                  if (res.data.code === "0") {
                      this.$messageSuccess('删除成功');
                      this.loading = true;
                      this.getTeacherList();
                  } else {
                      this.$messageError(res.data.msg);
                  }
                });
        })
        .catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
        });
    },
    // 添加教师显示
    showTeacher(){
      this.teacherDialogVisible = true;
      this.$ajax.get('/api-resource/cjdd-resources/school/teachers/subject?subjectId='+this.$route.query.subjectId+'&mobile='+this.nameMobile+'&name='+this.nameMobile).then(res=>{
        if(res.data.code == 0){
          this.tabload = false;
          this.teacherDataCheck = res.data.data;
          this.$nextTick(()=>{
            this.teacherDataCheck.forEach(row=>{
              if(row.userIsExistSubject){
                this.$refs.multipleTable.toggleRowSelection(row,true);
              }
            });
          });
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    // 清空老师
    emptyTeacher(row){
      row.forEach(item=>{
        if(!item.userIsExistSubject){
          this.$refs.multipleTable.toggleRowSelection(item,false);
        }
      });
    },
    // 默认选中
    selectable(row){
      if(!row.userIsExistSubject){
        return true
      }else{
        return false
      }
    },
    // 选中老师
    handleSelectionChange(val) {
      let newArr = val;
      this.$nextTick(()=>{
        this.multipleSelection = newArr.filter(item => item.userIsExistSubject !== true);
        this.selectedData = newArr;
      });
    },
    // 添加教师保存
    handleTrainingeSite(type){
      if(type){
        let teacherArr = [];
        this.teacherData.forEach(item=>{
          teacherArr.push(item.userId);
        });
        this.multipleSelection.forEach(item=>{
          teacherArr.push(item.userId);
        })
        let teacherIds = teacherArr.join(',');
        this.$ajax.post("/api-resource/cjdd-resources/subject/teacher",{
          subjectId:this.$route.query.subjectId,
          subjectTeacher:teacherIds
        }).then(res=>{
          if(res.data.code == 0){
            this.loading = true;
            this.getTeacherList();
            this.teacherDialogVisible = false;
          }else{
            this.$messageError(res.data.msg);
          }
        }).catch(error=>{
          console.log(error);
        })
      }else{
        this.teacherDialogVisible = false;
      }
    },
    // 查询老师
    search(){
      this.tabload = true;
      this.showTeacher();
    },
    //添加岗位
    getPostList(){
      this.$ajax.get('/api-resource/station/'+this.$route.query.subjectId).then(rs=>{
        if(rs.data.code==0){
          this.postList = rs.data.data
        }else{
          this.$messageError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    addPost(){
      this.editPostId = ''
      this.postTitle = '添加岗位'
      this.postVisible = true
    },
    cancelAddPost(){
      this.postVisible = false
    },
    confirmAddPost(data){
      let obj = {}
      let url = ''
      if(this.editPostId==""){
        obj  = {
          "code": data.postCode,
          "name": data.postName,
          "subjectId": this.$route.query.subjectId,
        }
        url = this.$ajax.post('/api-resource/station/save',obj)
      }else{
        obj  = {
          "code": data.postCode,
          "name": data.postName,
          "id": this.editPostId,
          "subjectId": this.$route.query.subjectId,
        }
        url = this.$ajax.put('/api-resource/station/update',obj)
      }
      url.then(rs=>{
        if(rs.data.code==0){
          this.getPostList()
        }else{
          this.$messageError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
      this.postVisible = false
    },
    editPost(item){
      this.editPostId = item.id
      this.newPostForm = {
        postName:item.name,
        postCode:item.code
      },
      this.postTitle = '编辑岗位'
      this.postVisible = true
    },
    deletePost(id){
      this.$ajax.delete('/api-resource/station/'+this.$route.query.subjectId+'/'+id).then(rs=>{
        if(rs.data.code==0){
          this.getPostList()
        }else{
          this.$messagaError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    //添加公司
    getCompanyList(){
      this.$ajax.get('/api-resource/company/'+this.$route.query.subjectId).then(rs=>{
        console.log(rs)
        if(rs.data.code==0){
          this.companyList = rs.data.data
        }else{
          this.$messageError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    addCompany(){
      this.editCompanyId = ''
      this.companyTitle = '添加公司'
      this.companyVisible = true
    },
    cancelAddCompany(){
      this.companyVisible = false
    },
    confirmAddCompany(data){
      let obj = {}
      let url = ''
      if(this.editCompanyId==""){
        obj  = {
          "name": data.companyName,
          "lableIds": data.useScope,
          "subjectId": this.$route.query.subjectId,
          "templateCode": data.companyCode,
        }
        url = this.$ajax.post('/api-resource/company/save',obj)
      }else{
        obj  = {
          "id": this.editCompanyId,
          "name": data.companyName,
          "lableIds": data.useScope,
          "subjectId": this.$route.query.subjectId,
          "templateCode": data.companyCode,
        }
        url = this.$ajax.put('/api-resource/company/update',obj)
      }
      url.then(rs=>{
        if(rs.data.code==0){
          this.getCompanyList()
        }else{
          this.$messageError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
      this.getCompanyList()
      this.companyVisible = false
    },
    editCompany(data){
      this.editCompanyId = data.id
      this.newCompanyForm = {
        companyName: data.name,
        companyCode: data.templateCode,
        useScope: data.lableIds
      },
      this.companyTitle = '编辑公司'
      this.companyVisible = true
    },
    deleteCompany(id){
      this.$ajax.delete('/api-resource/company/'+this.$route.query.subjectId+'/'+id).then(rs=>{
        if(rs.data.code==0){
          this.getCompanyList()
        }else{
          this.$messagaError(rs.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  }
};
</script>
<style scoped lang="scss">
.subject-detail {
  padding: 0 16px;
  .course_management_wrap {
    .course_management_title {
      height: 48px;
      border-bottom: 1px solid #5397f7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
      border-left: 2px solid rgba(83, 151, 247, 1);
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
      }
      .header_title_img{
          display: flex;
          align-items: center;
          color: #999999;
          margin-right: 4px;
      }
    }
  }
  .subject_wrap {
    overflow: auto;
  }
  .subject-detail-name {
    height: 66px;
    border-bottom: 1px solid #EBEBEB;
    display: flex;
    align-items: center;
    .ipt-wrap {
        width: 680px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 14px;
        }
        .el-input {
            width:240px;
            /deep/ .el-input__inner {
                height:34px;
                line-height: 34px;
            }
        }
        img {
            cursor: pointer;
        }
    }
    .btn-wrap {
        margin-left: 48px;
        .el-button {
            padding: 9px 25px;
        }
    }
  }
  .subject-detail-teacher,.subject-detail-catalog {
    height: 48px;
    border-bottom: 1px solid #5397f7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
        border: solid 1px #5397F7;
        color: #5397F7;
        &:hover {
            color:#fff;
            background: #5397F7;
        }
    }
    h2 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
    }
  }
  .teacher-table {
    margin-top: 12px;
    border: 1px solid #EBEBEB;
    /*border-bottom: 0;*/
    border-radius:4px;
    /deep/ .el-table th>.cell {
        font-weight: 400;
    }
    /deep/ .el-button--small, .el-button--small.is-round {
        padding: 5px 15px;
        color: #5397F7;
        font-size: 12px;
    }
  }
  .catalog-tree {
    margin-top: 6px;
    min-width: 200px;
    /deep/ .el-button--mini, .el-button--mini.is-round {
        padding: 5px 15px;
        color: #5397F7;
    }
    .custom-tree-node {
        flex: 1 1 0%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
        height: 100%;
        width: 90%;
        span:first-child{
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
    }
    /deep/ .el-tree-node__content {
        height: 40px;
    }
    .header_button{
      display: inline-block;
      cursor: pointer;
      color: #5397F7;
      font-size: 14px;
      margin-top: 5px;
      margin-left: 8px;
      img {
        display: inline-block;
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
    }
  }
  /deep/ .el-dialog__header {
    background: #edf4ff;
    border-radius: 8px 8px 0 0;
    height: 18px;
    &:before {
      width: 2px;
      height: 10px;
      background: rgba(83, 151, 247, 1);
      opacity: 1;
      border-radius: 4px;
    }
  }
  /deep/ .el-dialog__title {
    display: block;
    font-size: 14px;
    color: #5397f7;
    border-left: 2px solid #5397f7;
    padding-left: 5px;
    line-height: 10px;
  }
  /deep/ .el-dialog__footer {
    .el-button {
      width: 79px;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
  }
  /deep/ .el-dialog__body {
    padding: 24px 56px;
  }
  .teacher-content {
    height: 350px;
    border:1px solid rgba(226,226,226,1);
    border-radius:4px;
    .left {
      float: left;
      width: 539px;
      height: 100%;
      border-right: 1px solid rgba(226,226,226,1);
      .left-top {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 47px;
        border-bottom: 1px solid rgba(226,226,226,1);
        .el-input {
          width: 240px;
          margin-left: 10px;
        }
        /deep/ .el-input__inner {
          height: 34px;
          line-height: 34px;
        }
        /deep/ .el-input__icon {
          line-height: 34px;
        }
        .el-button {
          padding: 7px 19px;
          margin-left: 8px;
        }
      }
      .left-table {
        padding: 10px;
        .el-table {
          border: 1px solid #EBEBEB;
          border-bottom: 0;
          /deep/ .disabledCheck .cell .el-checkbox__inner{
            display: none!important;
          }
          /deep/ .disabledCheck .cell:before{
            content: '选择';
            position: absolute;
            right: 11px;
          }
        }

      }
    }
    .right {
      float: left;
      width: 178px;
      height: 100%;
      .right-top {
        padding: 0 12px;
        height: 47px;
        border-bottom: 1px solid rgba(226,226,226,1);
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          color: #999999;
          font-size: 14px;
        }
        .imgBox {
          display: flex;
          align-items: center;
          color: #666666;
          font-size: 12px;
          cursor: pointer;
          img {
            margin-right: 4px;
          }
        }
      }
      .right-cont {
        height: 290px;
        overflow: auto;
        padding-top: 12px;
        padding-left: 18px;
        .name_item {
          float: left;
          height: 20px;
          line-height: 20px;
          padding: 0 12px;
          margin-right: 36px;
          color: #5397F7;
          text-align: center;
          background-color:rgba(83,151,247,0.1);
          border-radius: 4px;
          margin-bottom: 8px;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
      }
    }
  }
  .add_post,.add_company{
    ul{
      li{
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
        box-sizing: border-box;
        span{
          font-weight:400;
          color:#262628;
          line-height: 40px;
          margin-left: 24px;
        }
        .el-button--mini.is-round[data-v-1094a5c9]{
          padding: 5px 15px;
          color: #5397F7;
        }
      }
    }
    .header_button{
      display: inline-block;
      cursor: pointer;
      color: #5397F7;
      font-size: 14px;
      margin-top: 5px;
      margin-left: 8px;
      img {
        display: inline-block;
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/sourcesubjectDetails.vue